import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const ALLOW_WHEN_PENDING = [
  "/pending-approval",
  "/verify-email",
  "/settings",
  "/profile",
];

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const isElevated = user.is_admin || user.is_super_admin;
  const notReady = !isElevated && (!user.email_verified || !user.is_approved);
  const path = location.pathname;
  const allowed = path.startsWith("/profile/") || ALLOW_WHEN_PENDING.some((p) => path === p || path.startsWith(p + "/"));
  if (notReady && !allowed) {
    return <Navigate to="/pending-approval" replace />;
  }
  return children;
}
